import moment from "moment";

import { getClientIpAddress } from "./ipUtil";
import { getUsernameFromToken } from "../redux/actions/auth";
import { trackEvent } from "./EventTrackingUtil";
import { CarrierToInsurancePolicyNameMap } from "@/core/constants";

/**
 * @deprecated This function is only asynchronous due to fetching of client IP, which we no longer
 * do, see https://aptihealth.atlassian.net/issues/AT1-6695. Use createAcknowledgementV2 instead
 */
export const createAcknowledgement = async ({ consentResponse }) => {
  const clientIp = await getClientIpAddress();

  return {
    acknowledged_by: getUsernameFromToken() || "self",
    client: "web",
    client_ip: clientIp,
    consent_response: consentResponse,
    date: moment.utc().toISOString(),
    timezone: moment.tz.guess(),
  };
};

/**
 * @deprecated When developing new features use the typed version of this helper "createAcknowledgementTyped"
 */
export const createAcknowledgementV2 = ({
  consentResponse,
  policyVersion,
  isGivenOnBehalf,
} = {}) => {
  const acknowledgement = {
    acknowledged_by: getUsernameFromToken() || "self",
    client: "web",
    consent_response: consentResponse,
    date: moment.utc().toISOString(),
    timezone: moment.tz.guess(),
    ...(policyVersion && { version: policyVersion }),
    ...(isGivenOnBehalf && { consent_given_by: getUsernameFromToken() }),
  };

  return acknowledgement;
};

export const createInsurancePolicyAcknowledgement = async (insuranceCarrier) => {
  const policyName = CarrierToInsurancePolicyNameMap[insuranceCarrier];

  return {
    [policyName]: await createAcknowledgement({ consentResponse: true }),
  };
};

export const trackPolicyAcknowledgement = (policyName) => {
  trackEvent("Policy acknowledged", { policyName });
};

export const trackInsurancePolicyAcknowledgement = (carrierName) => {
  const policyName = CarrierToInsurancePolicyNameMap[carrierName];

  trackPolicyAcknowledgement(policyName);
};
